
import { ApiError } from "@/lib/ftv-api/api-error";
import { apiFetch } from "@/lib/ftv-api/api-ftv";
import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";

export const fetchCurrentUser = createAsyncThunk(
  "currentUser/fetchCurrentUser",
  async ({ loginDetail, locale }, { rejectWithValue }) => {
    try {
      const res = await apiFetch(`/api/${locale}/user-login`, {
        method: "POST",
        body: JSON.stringify(loginDetail),
        cache: "no-store",
      });

      if (!res || !res.data) {
        return rejectWithValue("Invalid server response");
      }

      return res.data;
    } catch (error) {
      if (error instanceof ApiError) {
        return rejectWithValue(error.message);
      }

      return rejectWithValue("Something went wrong");
    }
  }
);


const currentUserSlice = createSlice({
  name: "currentUser",
  initialState: {
    currentUser: null,
    loading: false,
    error: null,
    status: "idle",
  },
  reducers: {
    clearCurrentUser(state) {
      state.currentUser = null;
      state.status = "idle";
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchCurrentUser.pending, (state) => {
        state.loading = true;
        state.status = "loading";
        state.error = null;
      })
      .addCase(fetchCurrentUser.fulfilled, (state, action) => {
        state.loading = false;
        state.status = "succeeded";
        state.currentUser = action.payload;
      })
      .addCase(fetchCurrentUser.rejected, (state, action) => {
        state.loading = false;
        state.status = "failed";
        state.currentUser = null;
        state.error = action.payload;
      });
  },
});

export const { clearCurrentUser } = currentUserSlice.actions;
export default currentUserSlice.reducer;
